import React from 'react';
import { FaTools, FaCheckDouble, FaUserGraduate, FaClock } from "react-icons/fa";
import '../styles/OnSiteSupport.css'; // Make sure this path matches your project structure

const OnSiteSupport = () => {
  const handleScroll = (sectionId) => {
    const target = document.getElementById(sectionId);
    if (target) {
      const offset = 80; // Adjust based on navbar height
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }};
  return (
    <section className="onsite-support">
      <div className="container">
        {/* Left Content */}
        <div className="content-left">
          <h2 className="title">
            On-Site Support & <span className="highlight">Commissioning</span>
          </h2>
          <p className="description">
            We don't just deliver automation systems – we ensure they're properly installed,
            configured, and optimized for your specific needs with our professional on-site support
            and commissioning services.
          </p>

          <ul className="services-list">
            <li className="service-item">
              <FaTools className="icon" />
              <div>
                <h4 className="service-title">Installation & Setup</h4>
                <p className="service-description">
                  Expert installation and setup of all automation equipment by our trained technicians.
                </p>
              </div>
            </li>
            <li className="service-item">
              <FaCheckDouble className="icon" />
              <div>
                <h4 className="service-title">Commissioning</h4>
                <p className="service-description">
                  Complete commissioning services to ensure your systems are operating at peak efficiency.
                </p>
              </div>
            </li>
            <li className="service-item">
              <FaUserGraduate className="icon" />
              <div>
                <h4 className="service-title">Training</h4>
                <p className="service-description">
                  Comprehensive operator training to ensure your team can effectively use and maintain the systems.
                </p>
              </div>
            </li>
            <li className="service-item">
              <FaClock className="icon" />
              <div>
                <h4 className="service-title">Emergency Support</h4>
                <p className="service-description">
                  Rapid response emergency support to minimize downtime and keep your operations running.
                </p>
              </div>
            </li>
          </ul>

          <button className="request-button"onClick={() => handleScroll("contactform")}>
            Request Support
          </button>
        </div>

        {/* Right Image */}
        <div className="content-right">
          <div className="image-main">
            <img
              src="/assets/images/image2.jpg" // Update the path with your actual image location
              alt="On-site technician"
              className="image-full"
            />
          </div>
          <div className="image-gallery">
            <img
              src="/assets/images/image3.jpg" // Update the path
              alt="Control room"
              className="image-half"
            />
            <img
              src="/images/support-team.jpg" // Update the path
              alt="Support team"
              className="image-half"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnSiteSupport;
